import { IAction } from "../../../UI.Controls/Actions/IAction";
import { GenericControl } from "../Controls/Control";
import { GenericControlParams } from "../Controls/ControlInterfaces";
/**Predek pro ovladaci prvky stranky menu (zalozka, skupina, action)*/
export class ToolbarControl extends GenericControl {
    //#region Constructors
    constructor(params: GenericControlParams) {
        super(params);
    }

    //#region Constructors
}

/**
 * Interface pro prvky toolbaru, ktere muzou obsahovat Akce.
 */
export interface ContainerToolbarControl {
    addAction(action: IAction): void;
    removeAction(action: IAction): void;
}
